import React from "react";

import { BUCKET_META, BUCKET_META_STYLES } from "../config/stakeholderLaneConfig";
import StakeholderCard from "./StakeholderCard";

export default function StakeholderBucketSection({ bucket, items, onOpen }) {
  const meta = BUCKET_META[bucket];
  const styles = BUCKET_META_STYLES[bucket];
  const visibleItems = items.slice(0, 3);
  const overflow = Math.max(0, items.length - visibleItems.length);

  return (
    <section className={`rounded-2xl border bg-white/75 p-3 dark:bg-white/[0.02] ${styles.borderClass}`}>
      <div className="flex items-center justify-between gap-3">
        <h3 className={`text-xs font-semibold uppercase tracking-[0.22em] ${styles.headingClass}`}>
          {meta.label}
        </h3>
        <span className="text-xs font-medium text-slate-500 dark:text-slate-400">{items.length}</span>
      </div>

      <div className="mt-3 space-y-3">
        {visibleItems.length ? (
          visibleItems.map((item) => <StakeholderCard item={item} key={item.id} onOpen={onOpen} />)
        ) : (
          <p className="rounded-xl border border-dashed border-slate-200 px-3 py-4 text-sm leading-6 text-slate-500 dark:border-white/10 dark:text-slate-400">
            {meta.empty}
          </p>
        )}

        {overflow > 0 ? (
          <p className="text-xs font-medium text-slate-500 dark:text-slate-400">+{overflow} more</p>
        ) : null}
      </div>
    </section>
  );
}
